import { render, staticRenderFns } from "./otherEquipmente.vue?vue&type=template&id=2883c912&scoped=true"
import script from "./otherEquipmente.vue?vue&type=script&lang=js"
export * from "./otherEquipmente.vue?vue&type=script&lang=js"
import style0 from "./otherEquipmente.vue?vue&type=style&index=0&id=2883c912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2883c912",
  null
  
)

export default component.exports